import RetailerUserView from './components/RetailerUserView';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import has from 'lodash/has';
import get from 'lodash/get';
import {connect} from 'react-redux';

import {
  loadRetailer,
  loadAppUser,
  loadLoyaltyBalance
} from '../../shared/redux/entities/actions'

function getTimelineItemsForUser(state,appUserId){
  if(!has(state,['entities','appUsers',appUserId])){
    return [];
  }

  const appUser = get(state,['entities','appUsers',appUserId]),
    campaigns = get(state,['entities','appUsers',appUserId,'campaignCompletions'],[]),
    responses = get(state,['entities','appUsers',appUserId,'responses'],[]);

    const campaignsWithTimeStamps = campaigns.map((c) => {
      c.timelineKind = 'completion';
      c.timestamp = c.dateEnded;
      c.engagementKind = null;

      return c;
    });

    const responsesWithTimeStamps = responses.map((r) => {
      r.timelineKind = 'response';
      r.timestamp = r.createdDate;
      r.engagementKind = r.kind;

      return r;
    });


    return [{timelineKind:'signup',timestamp:appUser.createdDate}]
      .concat(responsesWithTimeStamps,campaignsWithTimeStamps)
      .sort((a,b) => b.timestamp - a.timestamp);
}

function mapStateToProps(state,props){
  const retailerId = props.retailerId,
    appUserId = props.match.params.appUserId;

  return {
    retailerId:retailerId,
    appUserId:appUserId,
    loyaltyId:get(state,['entities','appUsers',appUserId,'displayId']),
    loyaltyBuffer:get(state,['entities','appUsers',appUserId,'loyaltyBuffer'],0),
    loyaltyBalance:get(state,['entities','appUsers',appUserId,'loyaltyBalance'],0),
    queryBuffer:get(state,['entities','appUsers',appUserId,'couponBufferBalance'],0) || 0, //TODO GET THIS FIXED ON BACKEND
    queryBalance:get(state,['entities','appUsers',appUserId,'cardBalance'],0),
    lifetimeUse:get(state,['entities','appUsers',appUserId,'lifetimeUse'],0),
    appUser:get(state,['entities','appUsers',appUserId]),
    retailerName:get(state,['entities','companies',retailerId,'name']),
    timelineItems:getTimelineItemsForUser(state,appUserId)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadRetailer,
    loadAppUser,
    loadLoyaltyBalance
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RetailerUserView));



// WEBPACK FOOTER //
// ./src/routes/RetailerUserView/index.js